module.exports = __webpack_public_path__ + "img_parallax.db72ad503b82bff98e6e.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/benge/Angular/my-first-app/src/assets/images/img_parallax.png
// module id = ../../../../../src/assets/images/img_parallax.png
// module chunks = main